import App from './App.svelte';
import 'materialize-css/dist/css/materialize.css';
import 'materialize-css/dist/js/materialize.js';
const app = new App({
	target: document.body,
});

export default app;